<template>
	<div>
		<app-modal-entrada :content="content" :entradaId="entradaId" v-if="showModalAdd"></app-modal-entrada>
		<el-form @submit.native.prevent="save" ref="form" label-position="top">
			<el-row type="flex" justify="space-between">
				<el-col :span="6">
					<el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
						<el-input v-model="template.title"></el-input>
						<div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
					</el-form-item>
				</el-col>
				<el-col :span="1"></el-col>				
				<el-col :span="6">
					<el-form-item label="Tipo de listado">
						<select class="select" v-model="template.tipo">
							<option value="1">Tabla</option>
							<option value="2">Tabla con imagen</option>
							<option value="3">Galería</option>
						</select>
					</el-form-item>
				</el-col>
				<el-col :span="1"></el-col>
				<el-col :span="4">
					<el-form-item label="Buscador">
						<el-radio-group v-model="template.search">
							<el-radio-button :label="1">Sí</el-radio-button>
							<el-radio-button :label="2">No</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</el-col>

				<el-col :span="1"></el-col>

				<el-col :span="6">
					<el-form-item label="Toggle">
						<el-radio-group v-model="template.toggle">
							<el-radio-button :label="1">Abierto</el-radio-button>
							<el-radio-button :label="2">Cerrado</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</el-col>

			</el-row>

			<el-row type="flex" justify="space-between">
				<el-col :span="24">
					<el-form-item label="Texto descriptivo del listado" v-if="showEditor">
						<app-vue-editor :value="template.description"></app-vue-editor>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<template v-if="content">
			<button	@click="addItem()" 
					class="el-button el-button--primary">
					<span>Añadir entrada</span> 
					<i class="el-icon-circle-plus"></i>
			</button>
			<br />
			<br />
			<app-modal-draggable v-if="modalDraggable" :content="fecthItems" :name="'title'" :table="'listados_entradas'"></app-modal-draggable>  
			<app-table-paginate v-if="fecthItems.length > 0" :draggable="true" :move="true" :routeEdit="routeEdit" :routeDelete="routeDelete" :tableQuery="fecthItems" :tableColumns="tableColumns" ></app-table-paginate>
		</template>
	</div>
</template>

<script>
	import ApiService from "@/common/api.service"
	import tablaConPaginador from '@/components/_commons/tablaConPaginador'
	import entrada from '@/components/Dashboard/Modals/addEntrada'
	import tablaConPaginadorVue from '@/components/_commons/tablaConPaginador';
	import { API_UPLOADS } from "@/common/config";
	import Draggable from '@/components/Dashboard/Modals/draggable'
	import Editor from '@/components/_commons/vue-editor'

	export default {
		name: "listado",
		props: ["content"],
		components: {
			'app-vue-editor': Editor,
			'app-table-paginate': tablaConPaginador,
			'app-modal-entrada': entrada,
			'app-modal-draggable': Draggable	
		},
		created() {
			this.routeEdit = 'modal'
			this.routeDelete = 'listadoDocumento'

			if (this.content) {
				this.getTableData()
				this.getContent()
			}

			this.$root.$on('openModal', (id)=> {
				setTimeout(() => {
					this.addItem(id)
				}, 300);
				
			})
			this.$root.$on('closeModal', ()=> {
				this.showModalAdd = false
				this.getTableData()
			})
			this.$root.$on("saveContent", (id) => {
				this.id = id;
				this.section_id = id
				this.setSave();
			});

            this.$root.$on('listadoDocumento', (id) => { this.eliminarRegistro(id)})
			this.$root.$on('draggable', (e) => this.showDraggable() )
            this.$root.$on('closeModal', () => this.closeModal() )
			this.$root.$on('vue-editor', (e) => { this.template.description = e})
		},
		watch: {
			$route(to) {
				if (this.content) this.getContent();
			}
		},
		data() {
			return {
				table: "listados",
				template: {
					title: "",
					description: "",
					tipo: 1,
					search: 2,
					toggle: 1
				},
				errorTitle: false,
				message: false,
				id: false,
                tableColumns: [
					{ 
						'prop': 'url',
						'label': 'Imagen'
					},
					{
                       'prop': 'title',
                       'label': 'Título' 
					},
					{
                       'prop': 'name',
                       'label': 'Autor' 
                    },
                ],		
                tableQuery: {},
                tableData: [],
                routeEdit: null,
				deleterow: false,
				showModalAdd: false,
				showTabla: false,
				api_uploads: API_UPLOADS,
				entradaId: false,
				modalDraggable: false,
				showEditor: false
			}
		},
		methods: {
			async getContent() {
				const a = await ApiService.post("dashboard/table", {
					table: "listados",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					id: this.content
				})
				
				this.template = a.data
				this.showEditor = true
			},
            async getTableData() {
				this.tableData = []
                const a = await ApiService.post("dashboard/listtablelistadoycontents", {
                    table: 'listados_entradas',
					token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    listado_id: this.content
				})

				if(a.data !== 'Algo ha fallado'){
					this.tableData = a.data.filter( (data)=> {
						data.url = this.api_uploads + data.url
						data.move = '/dashboard/' + this.$route.params.db + '/form/edit/entradas/' + data.id
						return data
					})
				}
            },
			setSave() {
				this.content != 0 ? this.update() : this.insert();
			},
			async update() {
				const a = await ApiService.post("dashboard/editform", {
					table: "listados",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: this.template,
					id: this.content
				})
				if(a.status === 200){
					
					// this.$router.go()
				}
			},
			async insert() {
				const a = await ApiService.post("dashboard/editform", {
					table: "listados",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: this.template
				})
				if(a.status === 200){
					const b = await ApiService.post("dashboard/editform", {
						table: "contents",
						token: localStorage.getItem("token"),
						project_id: localStorage.getItem("table"),
						form: {
							template_id: 2,
							registro_id: a.data
						}
					})
					if(b.status === 200){
						await ApiService.post("dashboard/editform", {
							table: "sections_contents",
							token: localStorage.getItem("token"),
							project_id: localStorage.getItem("table"),
							form: {
								section_id: this.section_id,
								content_id: b.data
							}
						})
					}
				}
			},
			addItem(id = null) {
				this.entradaId = id				
				this.showModalAdd = !this.showModalAdd
			},
			async eliminarRegistro(id) {
                const a = await ApiService.post("dashboard/delete", {
                    table: 'entradas',
                    token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    id: id
				})
				if(a.status === 200){
                    this.deleterow = a.data
					if(this.deleterow == 1){
						this.$message({
							type: 'success',
							message: 'Se ha eliminado correctamente'
						});
						this.getTableData()
					}else{
						this.$message({
							type: 'warning',
							message: this.deleterow
						});
					}
				}

			},
			showDraggable() {
				this.modalDraggable = true
			},
			closeModal(){
				this.modalDraggable = false
				this.getTableData()
			}
		},
		computed: {
			fecthItems(){
				return this.tableData
			}
		}
	}
</script>

<style>
	.el-upload__input {
		display: none !important;
	}
	.div-cropper {
		height: 500px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/listado.vue